function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M10 .5C6.179.5 2.714 2.429.156 5.562a.686.686 0 0 0 0 .872C2.714 9.571 6.18 11.5 10 11.5c3.821 0 7.286-1.929 9.844-5.062a.686.686 0 0 0 0-.872C17.286 2.429 13.82.5 10 .5zm.274 9.373c-2.536.147-4.631-1.782-4.472-4.126.131-1.933 1.83-3.5 3.924-3.62 2.536-.147 4.631 1.782 4.472 4.126-.135 1.929-1.833 3.495-3.924 3.62zm-.127-1.79c-1.366.08-2.495-.958-2.405-2.219.07-1.042.986-1.884 2.115-1.952 1.366-.079 2.495.96 2.405 2.22-.073 1.046-.99 1.888-2.115 1.952z"
});

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e56a9ef6.svg";
export { ForwardRef as ReactComponent };